import {
  BlendFunction,
} from 'postprocessing';
import {
  Vignette as VignettePass,
} from '@react-three/postprocessing';

export default function Vignette() {
  return (
    <VignettePass
      offset={ 0 }
      darkness={ 0.8 }
      eskil={ true }
      blendFunction={ BlendFunction.NORMAL }
    />
  );
};